module.exports = __webpack_public_path__ + "static/media/Sprint-Retro-3-Audio-1.cd9a629a.mp3";